module.exports = __webpack_public_path__ + "static/img/banner eureka.7fad6c7b.png";